// extracted by mini-css-extract-plugin
export default {"uiCard":"uiCard_uiCard__wk747","uiCardHeader":"uiCard_uiCardHeader__8uPUU","uiCardContent":"uiCard_uiCardContent__Jqvv1","uiCardHeaderAction":"uiCard_uiCardHeaderAction__Q9QMl"};